// extracted by mini-css-extract-plugin
export default {"explanerButton":"b3I2rYOr0guNjcZHYZVW8","content":"ehJs-5oIE9uIN1kjiOxvx","heading":"_1YxsmR0WPlH9y3xa2Qqq-Z","infoCircle":"y_Z27hHp6NJOXRJo5oBB2","list":"_1y3AHiGsmQl3GqwdBO64eT"};